import {
  UPDATE_USER_LOCATION,
  UserLocationActionTypes,
  UserLocationState
} from "./types";
import { UserLocation } from "../../models/User";

export function userLocationReducer(
  state = {} as UserLocation,
  action: UserLocationActionTypes
) {
  switch (action.type) {
    case UPDATE_USER_LOCATION:
      return action.payload;
    default:
      return state;
  }
}
